"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeManager = exports.NexusThemeManager = void 0;
/**
 * Nexus主题管理器
 * 负责主题注册、切换、CSS变量管理等
 */
class NexusThemeManager {
    constructor() {
        this.themes = new Map();
        this.currentTheme = 'default';
        this.cssVariables = new Map();
        this.styleElement = null;
        this.initializeDefaultThemes();
        this.createStyleElement();
    }
    static getInstance() {
        if (!NexusThemeManager.instance) {
            NexusThemeManager.instance = new NexusThemeManager();
        }
        return NexusThemeManager.instance;
    }
    /**
     * 初始化默认主题
     */
    initializeDefaultThemes() {
        // 默认主题
        this.registerTheme('default', {
            name: 'Default',
            colors: {
                primary: '#2563eb',
                primaryDark: '#1d4ed8',
                secondary: '#64748b',
                secondaryDark: '#475569',
                background: '#ffffff',
                surface: '#f8fafc',
                surfaceVariant: '#e2e8f0',
                text: '#1e293b',
                textSecondary: '#64748b',
                textOnPrimary: '#ffffff',
                border: '#e2e8f0',
                borderLight: '#f1f5f9',
                success: '#22c55e',
                warning: '#f59e0b',
                error: '#ef4444',
                info: '#3b82f6',
            },
            spacing: {
                xs: 4,
                sm: 8,
                md: 16,
                lg: 24,
                xl: 32,
            },
            fonts: {
                primary: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                secondary: 'Georgia, "Times New Roman", serif',
                mono: 'Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',
            },
            fontSize: {
                xs: 12,
                sm: 14,
                md: 16,
                lg: 18,
                xl: 20,
            },
            borderRadius: {
                sm: 4,
                md: 8,
                lg: 12,
            },
            shadows: {
                sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            },
            animations: {
                duration: {
                    fast: 150,
                    normal: 250,
                    slow: 400,
                },
                easing: {
                    ease: 'cubic-bezier(0.4, 0, 0.2, 1)',
                    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
                    easeOut: 'cubic-bezier(0, 0, 0.2, 1)',
                    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
                },
            },
        });
        // 暗色主题
        this.registerTheme('dark', {
            name: 'Dark',
            colors: {
                primary: '#3b82f6',
                primaryDark: '#2563eb',
                secondary: '#64748b',
                secondaryDark: '#475569',
                background: '#0f172a',
                surface: '#1e293b',
                surfaceVariant: '#334155',
                text: '#f1f5f9',
                textSecondary: '#94a3b8',
                textOnPrimary: '#ffffff',
                border: '#334155',
                borderLight: '#475569',
                success: '#22c55e',
                warning: '#f59e0b',
                error: '#ef4444',
                info: '#3b82f6',
            },
            spacing: {
                xs: 4,
                sm: 8,
                md: 16,
                lg: 24,
                xl: 32,
            },
            fonts: {
                primary: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                secondary: 'Georgia, "Times New Roman", serif',
                mono: 'Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',
            },
            fontSize: {
                xs: 12,
                sm: 14,
                md: 16,
                lg: 18,
                xl: 20,
            },
            borderRadius: {
                sm: 4,
                md: 8,
                lg: 12,
            },
            shadows: {
                sm: '0 1px 2px 0 rgba(0, 0, 0, 0.3)',
                md: '0 4px 6px -1px rgba(0, 0, 0, 0.4), 0 2px 4px -1px rgba(0, 0, 0, 0.3)',
                lg: '0 10px 15px -3px rgba(0, 0, 0, 0.4), 0 4px 6px -2px rgba(0, 0, 0, 0.3)',
            },
            animations: {
                duration: {
                    fast: 150,
                    normal: 250,
                    slow: 400,
                },
                easing: {
                    ease: 'cubic-bezier(0.4, 0, 0.2, 1)',
                    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
                    easeOut: 'cubic-bezier(0, 0, 0.2, 1)',
                    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
                },
            },
        });
        // Cocos Creator主题
        this.registerTheme('cocos', {
            name: 'Cocos Creator',
            colors: {
                primary: '#ff6b35',
                primaryDark: '#e55a2b',
                secondary: '#2c3e50',
                secondaryDark: '#1a252f',
                background: '#2c3e50',
                surface: '#34495e',
                surfaceVariant: '#4a5f7a',
                text: '#ecf0f1',
                textSecondary: '#95a5a6',
                textOnPrimary: '#ffffff',
                border: '#4a5f7a',
                borderLight: '#5d6d7e',
                success: '#27ae60',
                warning: '#f39c12',
                error: '#e74c3c',
                info: '#3498db',
            },
            spacing: {
                xs: 4,
                sm: 8,
                md: 16,
                lg: 24,
                xl: 32,
            },
            fonts: {
                primary: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                secondary: 'Georgia, "Times New Roman", serif',
                mono: 'Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',
            },
            fontSize: {
                xs: 12,
                sm: 14,
                md: 16,
                lg: 18,
                xl: 20,
            },
            borderRadius: {
                sm: 4,
                md: 8,
                lg: 12,
            },
            shadows: {
                sm: '0 1px 2px 0 rgba(0, 0, 0, 0.3)',
                md: '0 4px 6px -1px rgba(0, 0, 0, 0.4), 0 2px 4px -1px rgba(0, 0, 0, 0.3)',
                lg: '0 10px 15px -3px rgba(0, 0, 0, 0.4), 0 4px 6px -2px rgba(0, 0, 0, 0.3)',
            },
            animations: {
                duration: {
                    fast: 150,
                    normal: 250,
                    slow: 400,
                },
                easing: {
                    ease: 'cubic-bezier(0.4, 0, 0.2, 1)',
                    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
                    easeOut: 'cubic-bezier(0, 0, 0.2, 1)',
                    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
                },
            },
        });
    }
    /**
     * 创建样式元素
     */
    createStyleElement() {
        if (typeof document === 'undefined')
            return;
        this.styleElement = document.createElement('style');
        this.styleElement.setAttribute('data-nexus-theme', 'true');
        document.head.appendChild(this.styleElement);
    }
    /**
     * 注册主题
     */
    registerTheme(name, theme) {
        this.themes.set(name, theme);
        console.log(`主题 "${name}" 已注册`);
    }
    /**
     * 获取主题
     */
    getTheme(name) {
        return this.themes.get(name);
    }
    /**
     * 获取当前主题
     */
    getCurrentTheme() {
        return this.themes.get(this.currentTheme);
    }
    /**
     * 获取所有主题名称
     */
    getThemeNames() {
        return Array.from(this.themes.keys());
    }
    /**
     * 切换主题
     */
    setTheme(name) {
        const theme = this.themes.get(name);
        if (!theme) {
            console.error(`主题 "${name}" 不存在`);
            return false;
        }
        this.currentTheme = name;
        this.updateCSSVariables(theme);
        // 触发主题变更事件
        this.dispatchThemeChangeEvent(name, theme);
        console.log(`主题已切换为 "${name}"`);
        return true;
    }
    /**
     * 更新CSS变量
     */
    updateCSSVariables(theme) {
        if (!this.styleElement)
            return;
        const variables = this.generateCSSVariables(theme);
        this.styleElement.textContent = `:root {\n${variables}\n}`;
    }
    /**
     * 生成CSS变量
     */
    generateCSSVariables(theme) {
        const variables = [];
        // 颜色变量
        Object.entries(theme.colors).forEach(([key, value]) => {
            variables.push(`  --nexus-color-${this.kebabCase(key)}: ${value};`);
        });
        // 间距变量
        Object.entries(theme.spacing).forEach(([key, value]) => {
            variables.push(`  --nexus-spacing-${key}: ${value}px;`);
        });
        // 字体变量
        Object.entries(theme.fonts).forEach(([key, value]) => {
            variables.push(`  --nexus-font-${key}: ${value};`);
        });
        // 字体大小变量
        Object.entries(theme.fontSize).forEach(([key, value]) => {
            variables.push(`  --nexus-font-size-${key}: ${value}px;`);
        });
        // 圆角变量
        Object.entries(theme.borderRadius).forEach(([key, value]) => {
            variables.push(`  --nexus-border-radius-${key}: ${value}px;`);
        });
        // 阴影变量
        Object.entries(theme.shadows).forEach(([key, value]) => {
            variables.push(`  --nexus-shadow-${key}: ${value};`);
        });
        // 动画变量
        Object.entries(theme.animations.duration).forEach(([key, value]) => {
            variables.push(`  --nexus-duration-${key}: ${value}ms;`);
        });
        Object.entries(theme.animations.easing).forEach(([key, value]) => {
            variables.push(`  --nexus-easing-${key}: ${value};`);
        });
        return variables.join('\n');
    }
    /**
     * 将驼峰命名转换为kebab-case
     */
    kebabCase(str) {
        return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    }
    /**
     * 触发主题变更事件
     */
    dispatchThemeChangeEvent(themeName, theme) {
        if (typeof window !== 'undefined' && window.dispatchEvent) {
            const event = new CustomEvent('nexus-theme-change', {
                detail: { themeName, theme }
            });
            window.dispatchEvent(event);
        }
    }
    /**
     * 获取CSS变量值
     */
    getCSSVariable(name) {
        if (typeof document === 'undefined')
            return '';
        const value = getComputedStyle(document.documentElement).getPropertyValue(`--nexus-${name}`);
        return value.trim();
    }
    /**
     * 设置CSS变量
     */
    setCSSVariable(name, value) {
        if (typeof document === 'undefined')
            return;
        document.documentElement.style.setProperty(`--nexus-${name}`, value);
    }
    /**
     * 获取主题变量
     */
    getThemeVariables(themeName) {
        const theme = themeName ? this.getTheme(themeName) : this.getCurrentTheme();
        if (!theme)
            return {};
        const variables = {};
        // 展开所有主题属性为平面变量
        Object.entries(theme.colors).forEach(([key, value]) => {
            variables[`color-${this.kebabCase(key)}`] = value;
        });
        Object.entries(theme.spacing).forEach(([key, value]) => {
            variables[`spacing-${key}`] = `${value}px`;
        });
        Object.entries(theme.fonts).forEach(([key, value]) => {
            variables[`font-${key}`] = value;
        });
        Object.entries(theme.fontSize).forEach(([key, value]) => {
            variables[`font-size-${key}`] = `${value}px`;
        });
        Object.entries(theme.borderRadius).forEach(([key, value]) => {
            variables[`border-radius-${key}`] = `${value}px`;
        });
        Object.entries(theme.shadows).forEach(([key, value]) => {
            variables[`shadow-${key}`] = value;
        });
        Object.entries(theme.animations.duration).forEach(([key, value]) => {
            variables[`duration-${key}`] = `${value}ms`;
        });
        Object.entries(theme.animations.easing).forEach(([key, value]) => {
            variables[`easing-${key}`] = value;
        });
        return variables;
    }
    /**
     * 重置为默认主题
     */
    resetToDefault() {
        this.setTheme('default');
    }
    /**
     * 销毁主题管理器
     */
    destroy() {
        if (this.styleElement && this.styleElement.parentNode) {
            this.styleElement.parentNode.removeChild(this.styleElement);
        }
        this.themes.clear();
        this.cssVariables.clear();
    }
}
exports.NexusThemeManager = NexusThemeManager;
// 导出单例实例
exports.ThemeManager = NexusThemeManager.getInstance();
